import { AgmCoreModule } from '@agm/core';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';
import { CommonModule } from '@angular/common';
import { HttpClientJsonpModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { QRCodeModule } from 'angularx-qrcode';
import { QuillModule } from 'ngx-quill';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { MobxAngularModule } from 'mobx-angular';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MomentDateModule } from '@angular/material-moment-adapter';

import {
  AccordionModule,
  BlockUIModule,
  ButtonModule,
  CalendarModule,
  CarouselModule,
  ChartModule,
  CheckboxModule,
  ConfirmDialogModule,
  ContextMenuModule,
  DataViewModule,
  // DataGridModule NOW: DataViewModule,
  DragDropModule,
  DropdownModule,
  FieldsetModule,
  FileUploadModule,
  GalleriaModule,
  InputSwitchModule,
  InputTextareaModule,
  InputTextModule,
  ListboxModule,
  MenubarModule,
  MessagesModule,
  MultiSelectModule,
  OrderListModule,
  OverlayPanelModule,
  PanelMenuModule,
  PanelModule,
  PasswordModule,
  RadioButtonModule,
  RatingModule,
  ScrollPanelModule,
  SelectButtonModule,
  SharedModule,
  SliderModule,
  SpinnerModule,
  SplitButtonModule,
  StepsModule,
  TableModule,
  TabMenuModule,
  TabViewModule,
  ToggleButtonModule,
  TooltipModule,
  TreeModule,
  TreeTableModule,
  TriStateCheckboxModule,
} from 'primeng';
import { VmeLoggerModule } from '../../vme-logger.module';
import { HammerConfig } from './classes/HammerConfig';
import { StrongPasswordModule } from './modules/strong-password/strong-password.module';
import { NgxGalleryModule } from './user-controls/ngx-gallery/ngx-gallery.module';
import { AvatarModule } from './components/avatar/avatar';
import { NgxFileDropModule } from 'ngx-file-drop';
import { FullCalendarModule } from '@fullcalendar/angular';

const commonModules = [
  AccordionModule,
  AgmCoreModule,
  AgmJsMarkerClustererModule,
  AvatarModule,
  BlockUIModule,
  ButtonModule,
  CalendarModule,
  CardModule,
  CarouselModule,
  ChartModule,
  CheckboxModule,
  CommonModule,
  ConfirmDialogModule,
  ContextMenuModule,
  // DataGridModule, NOW: DataViewModule
  // DataScrollerModule, NOW: VirtualScrollerModule
  // DataTableModule, NOW: TableModule
  DataViewModule,
  DialogModule,
  DragDropModule,
  DropdownModule,
  FieldsetModule,
  FieldsetModule,
  FileUploadModule,
  FullCalendarModule,
  FormsModule,
  GalleriaModule,
  HttpClientJsonpModule,
  InputSwitchModule,
  InputTextModule,
  InputTextareaModule,
  ListboxModule,
  MobxAngularModule,
  MenubarModule,
  MessagesModule,
  MultiSelectModule,
  NgxGalleryModule,
  OrderListModule,
  OverlayPanelModule,
  PanelMenuModule,
  PanelModule,
  PasswordModule,
  QRCodeModule,
  QuillModule,
  RadioButtonModule,
  RatingModule,
  ReactiveFormsModule,
  RouterModule,
  // ScheduleModule, NOW: FullCalendarModule
  ScrollPanelModule,
  SelectButtonModule,
  SharedModule,
  SliderModule,
  SpinnerModule,
  SplitButtonModule,
  StepsModule,
  StrongPasswordModule,
  TableModule,
  TabMenuModule,
  TabViewModule,
  ToggleButtonModule,
  TooltipModule,
  TreeModule,
  TreeTableModule,
  TriStateCheckboxModule,
  VmeLoggerModule,
  NgxFileDropModule,
  MatDatepickerModule,
  MatSelectModule,
  MatFormFieldModule,
  MatInputModule,
  MatNativeDateModule,
  MatIconModule,
  MomentDateModule,
];

@NgModule({
  imports: [...commonModules],
  exports: [...commonModules],
  providers: [
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerConfig,
    },
  ],
})
export class VmeCommonModule {}
